import React from 'react'

const Footer = () => {
  return (
    <div>
        <pre>Designed By Esther Ogbu</pre>
    </div>
  )
}

export default Footer